import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { loadScript } from "@paypal/paypal-js";
import { getEnvConfig } from "@catchoftheday/env-config";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PayPalSDKContext = /*#__PURE__*/createContext({
  isSDKInitialising: true,
  payPalInstance: null
});
export var PayPalSDKProvider = function PayPalSDKProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(true),
      isSDKInitialising = _useState[0],
      setIsSDKInitialising = _useState[1];

  var _useState2 = useState(null),
      payPalInstance = _useState2[0],
      setPayPalInstance = _useState2[1];

  var loadPayPalSDK = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var paypal;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (getEnvConfig().PAYPAL_CLIENT_ID) {
              _context.next = 3;
              break;
            }

            throw new Error("PayPal client ID is not set");

          case 3:
            _context.next = 5;
            return loadScript({
              clientId: getEnvConfig().PAYPAL_CLIENT_ID,
              components: "messages"
            });

          case 5:
            paypal = _context.sent;
            setPayPalInstance(paypal);
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            // Log error to Stripe
            console.error(_context.t0);

          case 12:
            _context.prev = 12;
            setIsSDKInitialising(false);
            return _context.finish(12);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9, 12, 15]]);
  })), []);
  useEffect(function () {
    loadPayPalSDK();
  }, [loadPayPalSDK]);
  return ___EmotionJSX(PayPalSDKContext.Provider, {
    value: {
      isSDKInitialising: isSDKInitialising,
      payPalInstance: payPalInstance
    }
  }, children);
};